export default "__VITE_ASSET__BNTgoHd8__"